import React from "react";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import { Header, SlideLayout, Text } from "../../shared-components";
import aiSchedularAnimation from "./assets/ai-scheduler-animation.lottie";

export const AISchedulerSlide = () => {
  return (
    <SlideLayout>
      <Header>Say hello to easier scheduling</Header>
      <Text>
        With Clockwise AI Scheduler, you can schedule an impossible meeting or clear an entire day
        with a single chat.
      </Text>
      <LottiePlayer
        className="cw-mt-6 md:cw-mt-0 cw-border cw-border-solid cw-rounded-[14px] cw-border-default-pressed"
        autoplay
        loop
        src={aiSchedularAnimation}
      />
    </SlideLayout>
  );
};
